import React, { Component } from 'react'
import Input from 'shared-web/src/components/Input'
import IntegrationConnector from '../components/IntegrationConnector'
import { APP_URL, ZENDESK_CLIENT_ID } from 'constants/ResourcesConstants'
import ACCESS from 'utils/Access'

const ZendeskPayload = {
  client_id: ZENDESK_CLIENT_ID,
  response_type: 'code',
  redirect_uri: `${APP_URL}/accept-integration/zendesk`,
  scope: 'read write'
}

class Zendesk extends Component {
  state = {
    accountName: ''
  }

  renderInput = () => (
    <Input placeholder="ORG NAME" label="your organization name in zendesk"
      valueLink={{
        requestChange: (input) => {
          this.setState({ accountName: input})
        },
        value: this.state.accountName
      }}
      isValid={ !!this.state.accountName }
      />
    )

  render() {
    const { isConnected } = this.props
    const { accountName } = this.state
    const authLink = `https://${accountName}.zendesk.com/oauth/authorizations/new`
    const OauthPayload = { ...ZendeskPayload, state: accountName }

    return (
      <div>
        <p>Use Drift’s intelligent messaging to surface help article links from your Zendesk knowledge base.</p>
        <p>When Driftbot cannot find an article to help your customer, it will ask if they would like to create a ticket
        directly in the conversation. Just enter your organization name on Zendesk and we will handle the rest!</p>
        { isConnected ? null : this.renderInput() }
        <IntegrationConnector
          integrationId="zendesk"
          isOauth={true}
          oauthLink={authLink}
          oauthQueryParams={OauthPayload}
          />
      </div>
    )
  }
}

export default Zendesk



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/Zendesk.js